import { useNavigate } from 'react-router-dom'
import { LogOut, Menu } from 'lucide-react'
import { useAuth } from '../../hooks/useAuth'
import NotificationBell from '../notifications/NotificationBell'
import GlobalSearch from './GlobalSearch'

export default function Header({ onMenuClick }) {
  const { signOut, profile } = useAuth()
  const navigate = useNavigate()

  async function handleSignOut() {
    await signOut()
    navigate('/login')
  }

  return (
    <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center justify-between gap-3">
      {/* Hamburger — mobile only */}
      <button
        onClick={onMenuClick}
        className="p-2 text-gray-500 hover:text-gray-800 rounded-lg hover:bg-gray-100 transition-colors md:hidden"
        aria-label="Abrir menú"
      >
        <Menu size={20} />
      </button>

      {/* Global Search */}
      <div className="flex-1 max-w-sm hidden md:block">
        <GlobalSearch />
      </div>

      {/* Right side */}
      <div className="flex items-center gap-2">
        {/* Search on mobile */}
        <div className="md:hidden">
          <GlobalSearch />
        </div>
        <NotificationBell />
        <button
          onClick={handleSignOut}
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <LogOut size={16} />
          <span className="hidden sm:inline">Cerrar sesión</span>
        </button>
      </div>
    </header>
  )
}
